import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TResetPostCardNews, EResetPostCardNewsActionType } from './types';

export const resetPostCardNews: () => TResetPostCardNews = actionGenerator<EResetPostCardNewsActionType.Reset>(
  EResetPostCardNewsActionType.Reset,
);
